import { useNavigate } from 'react-router-dom';
import { v1 as uuidv1 } from 'uuid';
import UrlLink from './UrlLink';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './UrlLinkList.scss';

/**
 * The Url Link list component.
 * To easily customize anchor elements with theme colors and typography styles.
 *
 */
const defaultProps = {
  className: '',
  config: [],
};
export default function UrlLinkList(props) {
  const { className, config } = { ...defaultProps, ...filterUndefined(props) };
  const navigate = useNavigate();
  return (
    <div className={`url-link-list ${className}`} data-test='url-link-list'>
      {
        config.map((c) => (
          <UrlLink
            title={c.title}
            url={c.url}
            subUrls={c.subUrls}
            key={uuidv1()}
            onClick={() => { if (c.url) navigate(c.url); }}
            dataTest={c.dataTest}
          >
            {c.title}
          </UrlLink>
        ))
      }
    </div>
  );
}
